<template>
  <b-overlay :show="loading">
    <div v-if="inPreview">
      <a
        :href="pdfUrl"
        v-if="pdfUrl" target="_blank"
      >
        <h5
          class="text-primary underline d-inline-block mr-2"
          data-cy="document-viewer"
        >
          * Visualizando documento
          <small>(Formulario de Compras Adquisiciones)</small> *
        </h5>
        <feather-icon icon="ExternalLinkIcon" />
      </a>
      <pdf-preview-complete
        :inPreview="inPreview"
        :generatingPreview="generatingPreview"
        :saving="saving"
        :pdfUrl="pdfUrl"
        @in-preview="inPreview = $event"
        :backToForm="backToForm"
        :save="save"
      />
    </div>
    <div v-else>
      <form autocomplete="off" @submit.prevent>
        <h2>FORMULARIO DE COMPRAS ADQUISICIONES</h2>
        <div class="row mt-10">
          <div class="col-12">
            <b-form-group>
              <label for="previousDocument">
                ¿Deseas basarte en otro documento?
              </label>
              <v-select
                v-model="previousDocument"
                :options="createdDocuments"
                name="previousDocument"
                label="label"
                data-cy="created-document-data"
                @input="getDocumentData($event)"
                :clearable="true"
              >
                <template slot="no-options">
                  no hay documentos registrados
                </template>
              </v-select>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-4" v-if="!attachments || !attachments.length">
            <b-button
              variant="secondary"
              class="btn-icon mt-1 w-100"
              data-cy= "from-repository"
              v-has-permission="'ED060'"
              v-b-modal="'add-repository-file'"
              :disabled="attachments.length >= 1"
            >
              <feather-icon icon="ServerIcon"/>
              Seleccionar FISABS desde el repositorio
            </b-button>
          </div>
          <div
            class="col-12"
            v-for="file in attachments"
            :key="file.id"
            v-if="file.name && file.name.includes('FISABS')"
          >
            <div
              class="row align-items-center"
            >
              <vs-icon class="col-2" icon="description" size="25px" color="primary" />
              <b class="w-100 text-center col-8">{{ file.name }}</b>
              <vs-button
                class="col-2"
                color="danger"
                type="flat"
                icon="clear"
                @click="removeRepositoryFile(file.id)"
              />
            </div>
          </div>
          <div class="col-12" v-if="!attachments || !attachments.length">
            <span class="danger span-text-validation-danger v-enter-to">
              <small>
                Debes seleccionar un archivo desde el repositorio
              </small>
            </span>
          </div>
        </div>
        <div class="row" v-if="attachments && attachments.length && !loading">
          <div class="col-12">
            <vs-divider />
          </div>
          <div class="col-12 mt-5">
            <h4>SERVICIOS O PRODUCTOS</h4>
          </div>
          <div class="col-12">
            <div class="row mt-2" v-for="(item, index) in formData.items" :key="item.id">
              <div class="col-1 d-flex align-items-center">
                <b-button
                  v-if="item.selected  === true"
                  variant="success"
                  size="sm"
                  @click="unSelectItem(item)"
                >
                  selec.
                </b-button>
                <b-button
                  v-if="item.selected === false"
                  variant="secondary"
                  size="sm"
                  @click="selectItem(item)"
                >
                  no selec.
                </b-button>
              </div>
              <div class="col-5">
                <vs-input
                  label="Nombre de servicio"
                  class="w-100"
                  data-cy="name-service"
                  v-model="item.requiredServiceName"
                />
              </div>
              <div class="col-1">
                <vs-input
                  type="number"
                  class="w-100"
                  label="Cantidad"
                  data-cy="quantity"
                  v-model="item.serviceQuantity"
                />
              </div>
              <div class="col-2">
                <vs-input
                  type="number"
                  class="w-100 text-right"
                  label="Precio unitario"
                  data-cy="unit-price"
                  v-model="item.serviceAmount"
                  @input="changeReceivedQuantity(item)"
                />
              </div>
              <div class="col-2">
                <vs-input
                  type="number"
                  class="w-100 text-right"
                  label="Precio total"
                  data-cy="total-price"
                  v-model="item.serviceTotalAmount"
                  disabled
                />
              </div>
              <vs-divider />
            </div>
            <div class="row">
              <div class="col-9">
              </div>
              <div class="col-3 text-right">
                <b-button
                  variant="outline-warning"
                  size="sm"
                  @click="addItem()"
                >
                  agregar
                </b-button>
              </div>
            </div>
          </div>
          <vs-divider />
          <div class="col-6 mt-2">

          </div>
          <div class="col-6 mt-2">
            <div class="row">
              <div class="col-6 mt-3" v-if="!formData.exemptSell">
                Total Neto
              </div>
              <div class="col-6 mt-3" v-if="!formData.exemptSell">
                {{formData.netAmount | amount}}
              </div>
              <div class="col-6 mt-3" v-if="!formData.exemptSell">
                IVA (19%)
              </div>
              <div class="col-6 mt-3" v-if="!formData.exemptSell">
                {{formData.taxAmount | amount}}
              </div>
              <div class="col-6 mt-3">
                Subtotal
              </div>
              <div class="col-6 mt-3">
                {{formData.subtotal | amount}}
              </div>
              <div class="col-6 mt-3" v-if="formData.exemptSell">
                Monto Exento
              </div>
              <div class="col-6 mt-3" v-if="formData.exemptSell">
                {{formData.exemptAmount | amount}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <validate-field
              field="general-observations"
              label="Observaciones generales de la solicitud"
              v-slot="{ invalid }"
            >
              <b-form-textarea
                name="general-observations"
                v-model="formData.generalObservations"
                data-vv-as="observaciones generales de la solicitud"
                data-cy="general-observations"
                :state="invalid"
                :maxlength="2000"
                placeholder="Observaciones generales"
                rows="3"
                max-rows="8"
              />
              <small class="form-text text-muted text-right" v-if="formData.generalObservations">
                {{ formData.generalObservations ? formData.generalObservations.length : 0 }} / 2000
              </small>
            </validate-field>
          </div>
          <vs-divider />
          <div class="col-12">
            <h4>Documentos</h4>
          </div>
          <div class="col-12">
            <dynamic-file-selector
              v-if="!grcAttachmentsSelectors.loading"
              :selectors="grcAttachmentsSelectors.list
              .slice()
              .sort((a, b) => a.order - b.order)
              .map((sel) => ({ ...sel, ...sel.extra, index: sel.order }))
            "
              :object-to-evaluate="formData"
              :files="dynamicSelectorFiles"
              :reset-key="dfsResetKey"
              @update-files="updateFiles"
              @valid="(valid) => {
              dynamicFileSelectorValid = valid;
            }"
            />
            <div v-else>
              <b-skeleton animation="fade" width="100%"/>
              <b-skeleton animation="fade" width="100%"/>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <UploadFile
                  permission="*"
                  accept="application/pdf, .doc, .docx, .xlsx, .ppt"
                  text="Seleccionar documentos"
                  v-model="fileOthers"
                  upload-to="ed"
                  :button-class="{ 'btn-block': true,
                 'mb-5': errors.has('custom-document.fileName') }"
                  container-class="w-100"
                  @input="addOthersFile()"
                />
              </div>
              <div
                class="col-3"
                v-for="file in formData.attachments"
                :key="file.id"
                v-if="!file.name.includes('FISABS')"
              >
                <div class="d-flex flex-column align-items-center">
                  <vs-icon icon="description" size="45px" color="primary" />
                  <b class="text-truncate w-100 text-center">{{ file.name }}</b>
                  <vs-button
                    color="danger"
                    type="flat"
                    icon="clear"
                    @click="removeOthersFile(file.id)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="text-xs text-right">
        <b>Los campos marcados con <span class="text-danger">*</span> son obligatorios</b>
      </div>
      <form-buttons
        :saving="saving"
        :disabled="dfsSelectorsLoading"
        :back="() => this.$router.back()"
        :preview="preview"
        :save="save"
        :saveDraft="saveDraft"
      />
    </div>
    <repository-selector
      :add-file="addRepositoryFile"
      :files="attachments"
      :remove-file="removeRepositoryFile"
      :max-files="100"
      required-file-type="FISABS"
      :required-approval-state="approvalStateTypes.ON_APROBATION"
    />
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { BButton, BFormCheckbox } from 'bootstrap-vue';
import { uuid } from 'vue-uuid';

import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import { showToast } from '@/febos/global/customDocuments/utils/showToast';
import { showInvalidFormNotification } from '@/febos/global/customDocuments/utils/notifications';
import { getAttachmentsConfig } from '@/febos/global/customDocuments/utils/attachments';
import PdfPreviewComplete from '@/febos/global/customDocuments/components/PdfPreviewComplete';
import FormButtons from '@/febos/global/customDocuments/components/FormButtons';
import SelectOptions from '@/febos/global/customDocuments/components/SelectOptions';
import ValidateField from '@/febos/global/customDocuments/components/ValidateField';
import DatePicker from '@/febos/global/customDocuments/components/DatePicker';
import SelectGroups from '@/febos/global/customDocuments/components/SelectGroups';
import DynamicFileSelector from '@/febos/global/customDocuments/components/dynamic-file-selector/DynamicFileSelector';
import RepositorySelector from '@/febos/global/customDocuments/components/repository-selector/RepositorySelector';
import ApprovalStateTypes from '@/febos/global/documentManagement/mixins/ApprovalStateTypes';
import dataFISABS from '@/febos/global/customDocuments/vistas/empresas/61980520-8/dataFISABS';
import ListUser from '@/febos/chile/lists/components/ListUser';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import { getUsers } from '@/febos/servicios/api/usuarios.api';
import HandleDraft from "@/febos/global/documentManagement/mixins/HandleDraft";
import HandlePreLoadData from "@/febos/global/documentManagement/mixins/HandlePreLoadData";

const DOC_TYPE = 'GRC';
const OTHER_ADDRESS = 'Otra dirección';
const INITIAL_ITEM = {};

export default {
  name: DOC_TYPE,
  components: {
    UploadFile,
    ListUser,
    BButton,
    RepositorySelector,
    BFormCheckbox,
    DynamicFileSelector,
    SelectGroups,
    PdfPreviewComplete,
    FormButtons,
    ValidateField,
    SelectOptions,
    DatePicker,
  },
  mixins: [HandleDraft, HandlePreLoadData],
  data() {
    return {
      usersCompany: [],
      errorResponsible: false,
      OTHER_ADDRESS,
      loading: false,
      approvalStateTypes: ApprovalStateTypes,
      dynamicFileSelectorValid: false,
      usr: {},
      initialItem: { ...INITIAL_ITEM },
      attachments: [],
      fileOthers: {},
      dynamicSelectorFiles: [],
      otherCurrencies: [
        {
          id: 'USD',
          label: 'USD',
        },
        {
          id: 'UF',
          label: 'UF',
        },
        {
          id: 'UTM',
          label: 'UTM',
        },
      ],
      usersList: [],
      formData: {
        generalObservations: '',
        requesterName: '',
        requesterEmail: '',
        selectedFisabs: [],
        attachments: [],
        items: [],
        linked: [],
        netAmount: 0,
        discountAmount: 0,
        chargesAmountInput: 0,
        discountAmountInput: 0,
        retentionTaxInput: 0,
        retentionTax: 0,
        chargesAmount: 0,
        exemptSell: false,
        taxRetention: 0,
        taxAmount: 0,
        subtotal: 0,
        exemptAmount: 0,
        totalAmount: 0,
        totalGrossAmount: 0,
      },
      dfsValid: true,
      dfsSelectors: [],
      dfsSelectorsLoading: true,
      dfsFiles: [],
      saving: false,
      formFiles: [],
      error: {
        message: ''
      },
      // PDF Preview
      inPreview: false,
      generatingPreview: false,
      pdfUrl: '',

    };
  },
  computed: {
    ...mapGetters('List', [
      'grcAttachmentsSelectors',
    ]),
    ...mapGetters('Empresas', [
      'empresa',
    ]),
    dontApplyPenalty() {
      return this.formData.applyPenalty === false;
    },
    users() {
      return this.usersCompany
        .map((user) => ({ label: user.nombre, id: user.id, value: user.id }));
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchGrcAttachmentsSelectors',
      'fetchUsers'
    ]),
    updateFiles(files) {
      this.formFiles = [...files];
    },
    setRequester(user) {
      this.formData.requesterUser = user;
    },
    addServiceManager(user) {
      this.formData.responsibles = user;
    },
    addResponsible(user) {
      this.formData.responsibles = user;
    },
    removeOthersFile(fileId) {
      this.formData.attachments = this.formData.attachments
        .filter((file) => file.id !== fileId);
    },
    async addOthersFile() {
      if (!Object.keys(this.fileOthers).length) {
        return;
      }

      if (this.fileOthers.failed) {
        this.error.messageOthers = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.formData.attachments.push(this.fileOthers);
      this.error.messageOthers = '';
    },
    backToForm() {
      this.inPreview = false;
      this.formData.responsibleName = this.formData.responsibles.map((user) => user.id);
    },
    initialTotals() {
      this.formData = {
        ...this.formData,
        netAmount: 0,
        retentionTax: 0,
        discountAmount: 0,
        chargesAmount: 0,
        taxRetention: 0,
        taxAmount: 0,
        subtotal: 0,
        exemptAmount: 0,
        totalAmount: 0,
        totalGrossAmount: 0,
      };
    },
    calculateTotals() {
      this.initialTotals();
      this.formData.items.forEach((item) => {
        if (item.selected) {
          this.formData.exemptAmount += item.serviceTotalAmount;
          this.formData.subtotal += item.serviceTotalAmount;
          this.formData.totalGrossAmount = this.formData.subtotal - parseInt(this.formData.discountAmountInput || 0);
          if (this.formData.exemptSell) {
            this.formData.taxAmount = 0;
            if (this.formData.discountAmountInput) {
              this.formData.totalGrossAmount = Math.round(this.formData.exemptAmount - parseInt(this.formData.discountAmountInput || 0));
              this.formData.discountAmount = Math.round(parseInt(this.formData.discountAmountInput || 0));
            }
            if (this.formData.chargesAmountInput) {
              this.formData.totalGrossAmount = Math.round(this.formData.exemptAmount
                + parseInt(this.formData.chargesAmountInput || 0));
              this.formData.chargesAmount = Math.round(parseInt(this.formData.chargesAmountInput || 0));
            }
          } else {
            // this.formData.taxRetention = parseInt(this.formData.exemptAmount) * 0.13;
            this.formData.netAmount = Math.round(this.formData.totalGrossAmount / 1.19);
            this.formData.taxAmount = Math.round((parseInt(this.formData.netAmount) * 0.19));
            if (this.formData.discountAmountInput) {
              this.formData.discountAmount = Math.round(parseInt(this.formData.discountAmountInput || 0));
            }
            if (this.formData.chargesAmountInput) {
              this.formData.chargesAmount = Math.round(parseInt(this.formData.chargesAmountInput || 0));
            }
            this.formData.totalGrossAmount = Math.round(this.formData.totalGrossAmount
              + parseInt(this.formData.chargesAmountInput || 0));
          }
        }
      });
      if (this.formData.retentionTaxInput) {
        this.formData.retentionTax = Math.round(parseInt(this.formData.retentionTaxInput || 0));
        this.formData.totalGrossAmount = Math.round(parseInt(this.formData.totalGrossAmount) + parseInt(this.formData.retentionTaxInput));
      }
    },
    changeReceivedQuantity(item) {
      if (parseInt(item.serviceQuantityDelivered) > parseInt(item.serviceQuantity)) {
        item.serviceQuantityDelivered = item.serviceQuantity;
      }
      this.formData = {
        ...this.formData,
        items: this.formData.items.map((i) => {
          if (i.id === item.id) {
            return {
              ...i,
              serviceQuantityDelivered: parseInt(item.serviceQuantityDelivered),
              serviceTotalAmount: parseInt(item.serviceAmount) * parseInt(item.serviceQuantity)
            };
          }
          return i;
        }),
      };
      this.calculateTotals();
    },
    addItem() {
      const clean = {
        id: uuid.v4(),
        requiredServiceName: '',
        serviceQuantity: 0,
        selected: true,
        serieNumber: '',
        serviceManager: '',
        serviceQuantityDelivered: 0,
        serviceTotalAmount: 0,
        serviceAmount: 0
      };
      this.formData.items.push(clean);
    },
    selectItem(item) {
      this.formData = {
        ...this.formData,
        items: this.formData.items.map((i) => {
          if (i.id === item.id) {
            return {
              ...i,
              selected: true,
            };
          }
          return i;
        }),
      };
      this.changeReceivedQuantity(item);
    },
    unSelectItem(item) {
      this.formData = {
        ...this.formData,
        items: this.formData.items.map((i) => {
          if (i.id === item.id) {
            return {
              ...i,
              selected: false,
            };
          }
          return i;
        }),
      };
      this.changeReceivedQuantity(item);
    },
    async getSelectedFileData(file) {
      try {
        this.loading = true;
        const { id } = file;
        const { data } = await ioGetCustomDocument('FISABS', id, {});
        // this.formData = {};
        // const data = dataFISABS;
        console.log('FILE', file);
        console.log('data', data);
        const formatedItems = data.document.items
          .map((item) => {
            if (typeof item.serviceAmount === 'string') {
              item.serviceAmount = item.serviceAmount.replace(/\$/g, '').replace(/\./g, '');
            }
            return item;
          });

        this.formData.items =
          [...this.formData.items, ...formatedItems].map((item) => ({
            ...item,
            selected: false,
            serieNumber: '',
            serviceManager: '',
            serviceQuantityDelivered: item.serviceQuantity,
            serviceTotalAmount: parseInt(item.serviceAmount) * parseInt(item.serviceQuantity),
            serviceAmount: parseInt(item.serviceAmount)
          }
          ));
        this.formData.selectedFisabs.push(data.document);
        this.formData.itemsOriginal = [...this.formData.items];
        const linkedFisabs = {
          id: data.document.id,
          locationId: data.document.locationId,
          locationType: data.document.locationType,
        };
        const attachmentFisabs = data.document.attachments.map((fileAttach) => ({
          id: fileAttach.id,
          locationId: data.document.locationId,
          locationType: data.document.locationType
        }));
        this.formData.linked.push(linkedFisabs);
        this.formData.linked = this.formData.linked.concat(attachmentFisabs);
      } catch (e) {
        console.log('E', e);
      } finally {
        this.loading = false;
        this.$nextTick(() => {
          this.$validator.validateAll();
        });
      }
    },
    async loadAttachmentsConfig() {
      this.dfsSelectorsLoading = true;
      try {
        const { selectors } = await getAttachmentsConfig(DOC_TYPE);
        this.dfsSelectors = selectors;
      } finally {
        this.dfsSelectorsLoading = false;
        this.dfsValid = false;
      }
    },
    dfsUpdateFiles(files) {
      this.formData.attachments = [...files];
    },
    async addRepositoryFile(file) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.attachments.push(file);
      this.error.message = '';

      await this.getSelectedFileData(file);
    },
    removeRepositoryFile(id) {
      this.attachments = this.attachments.filter((file) => file.id !== id);
    },
    async validateForm() {
      this.errorResponsible = false;
      this.$validator.errors.clear();
      const validDynamicFileSelector = this.dynamicFileSelectorValid;
      const haveNames = this.formData.items.every((item) => item.requiredServiceName
        && item.serviceQuantity && item.serviceAmount);
      const selected = this.formData.items.some((item) => item.selected);
      if (!selected) {
        this.$vs.notify({
          title: 'Error al intentar emitir el documento',
          text: 'Debes seleccionar al menos un item',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
        return;
      }
      if (!haveNames) {
        this.$vs.notify({
          title: 'Error al intentar emitir el documento',
          text: 'Debes agregar el nombre, cantidad y/o precio de todos los servicios',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
        return;
      }
      const isUpperAmount = this.formData.totalGrossAmount > this.formData.totalFisabs;
      if (isUpperAmount) {
        this.$vs.notify({
          title: 'Ups!',
          text: 'El monto total de los servicios o productos supera el monto aprobado del FISABS',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
        return;
      }
      const fieldsValid = await this.$validator.validateAll();

      const result = !!fieldsValid
        && validDynamicFileSelector;

      if (!result) {
        this.$vs.notify({
          title: 'Ups!',
          text: 'Revisa los campos marcados en rojo',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
      }
      if (!fieldsValid) {
        showInvalidFormNotification(this);
      }

      return result;
    },
    getFormData(draft=false) {
      // Excluir de attachments los archivos que ya están en linked (FISABS)
      const linkedIds = new Set((this.formData.linked || []).map((l) => l.id).filter(Boolean));
      const filteredAttachments = (this.formData.attachments || [])
        .filter((f) => !linkedIds.has(f.id));
      return {
        ...this.formData,
        attachments: filteredAttachments,
        fisabsFilesSelected: this.attachments,
        items: this.formData.items
          .filter((item) => draft || item.selected)
          .map((item, indexMap) => ({ ...item, index: indexMap + 1 })),
        linked: [
          ...this.formData.linked,
        ]
      };
    },
    async generatePdf(id) {
      showToast(this, 'Generando archivo PDF', 'En camino...');
      const response = await ioGetCustomDocument(this.$route.params.type, id, { pdf: 'si' });
      showToast(this, 'Archivo generado', 'Listo!', { variant: 'success', autoHideDelay: 3000 });
      window.open(response.data.pdf, '_blank');
      setTimeout(() => window.history.back(), 2000);
    },
    async save() {
      if (!await this.validateForm()) return;
      const from = this.$route.query?.from;
      this.saving = true;
      try {
        showToast(this, 'Guardando documento', 'En camino...', { variant: 'primary', autoHideDelay: 2000 });

        console.log('DATA', this.getFormData());
        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            numerar: 'si',
            ...(from === 'draft' && { replace: 'si' }),
          },
          formData: this.getFormData(),
        };
        const response = await ioCreateCustomDocument(payload);
        await this.notifyCreation(response.data.name || '');
        await this.generatePdf(response.data.document.id);
      } finally {
        this.saving = false;
      }
    },
    async saveDraft() {
      this.saving = true;
      const { from } = this.$route.query;
      try {
        showToast(this, 'Guardando documento', 'En camino...', { variant: 'primary', autoHideDelay: 2000 });
        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            numerar: 'no',
            ...(from === 'draft' && { replace: 'si' })
          },
          formData: {
            ...this.getFormData(true),
            status: '3'
          },
        };

        const response = await ioCreateCustomDocument(payload);
        const docId = response.data?.document?.id || response.data?.documentId;
        if (docId) {
          await this.updateRouteAsDraft(docId);
        }
        showToast(this, 'Borrador guardado correctamente', '¡Listo!', { variant: 'success', autoHideDelay: 3000 });
      } finally {
        this.saving = false;
      }
    },
    async preview() {
      const isValid = await this.validateForm();
      if (!isValid || !this.attachments || !this.attachments.length) {
        return;
      }

      this.pdfUrl = '';
      this.inPreview = true;
      this.generatingPreview = true;

      try {
        showToast(this, 'Generando previsualización', 'En camino...', 'primary', 3000);

        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            simular: 'si',
          },
          formData: {
            ...this.getFormData(),
            borrador: true,
          }
        };

        const { data: { pdf } } = await ioCreateCustomDocument(payload);

        if (!pdf || pdf === '') {
          showToast(this, 'No se pudo generar la previsualización', 'Ups!', 'warning', 5000);
          this.backToForm();
        }

        this.pdfUrl = `${pdf}#toolbar=0&navpanes=0&scrollbar=0`;
      } catch (e) {
        console.log('EERRPPR', e);
      } finally {
        this.generatingPreview = false;
      }
    },
  },
  async mounted() {
    this.formData.requesterName = this.usr.nombre || '';
    this.formData.requesterEmail = this.usr.correo || '';

    const { data: { usuarios } } = await getUsers({
      empresaId: this.empresa.id,
      page: 1,
      limit: 9999,
      query: ''
    });

    this.usersCompany = usuarios;
  },
  created() {
    this.usr = this.$store.getters['Usuario/currentUser'];
    this.loadAttachmentsConfig();
    this.fetchGrcAttachmentsSelectors();
  },
};
</script>
<style>

</style>
